import { Status } from '../lib/constants';
import { statusHelper } from './helpers/login';
import { logSending } from './helpers/loger';
import { GameConfigs } from '../lib/globals/GameConfigs';
import handleError from '../helpers/gameHandlers/handleError';
const END_MESSAGE = '\r\n';

export class WS {
	constructor(WS_URL, receiveMessage) {
		this.websocket = null;
		this.WS_URL = WS_URL;
		this.receiveMessage = receiveMessage;
		// this.name = name
		this.reconnectTimeout = 0;
		this.pingInterval = 0;
		this.count = 0;
		this.msgBuffer = '';
	}
	start() {
		console.log(
			`%cStart websocket to ${this.WS_URL}`,
			'color:black; background: #0b646f; padding: 10px; border-radius: 12px;'
		);
		this.websocket = new WebSocket(this.WS_URL);
		this.websocket.onopen = (evt) => this.onopen(evt);
		this.websocket.onmessage = (evt) => this.onReceiveMessage(evt);
		this.websocket.onclose = (evt) => this.onclose(evt);
		this.websocket.onerror = (evt) => this.onerror(evt);
		return this;
	}
	onclose(e) {
		this.disconnect();
		console.log({ e }, 'onClose');
	}

	onReceiveMessage(evt) {
		try {
			var msg = evt.data;
			this.msgBuffer += msg;
			if (this.msgBuffer.indexOf(END_MESSAGE) !== -1) {
				var splited = this.msgBuffer.split(END_MESSAGE);
				splited.forEach((item) => {
					if (item.length > 0) {
						this.receiveMessage(JSON.parse(item));
					}
				});
				this.msgBuffer = splited[splited.length - 1];
			}
		} catch (error) {
			this.onerror();
			console.log(error);
		}
	}

	sendMessage(msg, callback) {
		const parsed = JSON.parse(msg);
		if (parsed.service !== 'ping') {
			this.count = 0;
		}
		logSending(msg);
		if (this.websocket.readyState === WebSocket.OPEN) this.websocket.send(msg);
		if (callback) {
			callback(msg);
		}
	}

	onopen() {
		console.log('%cOPEN CONNECTION <3', 'color:white; padding: 10px;');
		this.setStatus(Status.CONNECTED);
		this.pingInterval = setInterval(
			this.pingIntervalFunc.bind(null, this),
			5000
		);
	}
	pingIntervalFunc(self) {
		const msg = JSON.stringify({ service: 'ping', data: {} });
		self.count++;
		if (GameConfigs.errors.code > 0) {
			clearInterval(self.pingInterval);
			self.disconnect();
		} else {
			self.sendMessage(msg);
		}
	if (self.count >= 60) {
			self.disconnect();
		}
	}

	onerror(e) {
		console.log({ e }, GameConfigs.errors, 'on error in websocket');
		// this.disconnect()
	}

	disconnect() {
		clearInterval(this.pingInterval);
		clearTimeout(this.reconnectTimeout);
		this.setStatus(Status.DISCONNECTED);
		this.websocket.onerror = null;
		this.websocket.onopen = null;
		this.websocket.onReceiveMessage = null;
		this.websocket.onclose = null;
		this.websocket.close();
		console.log('disconnect');
		if (GameConfigs.errors.code > 0) {
			handleError(GameConfigs.errors, GameConfigs.App);
		} else {
			handleError(
				{
					code: 1000,
					message: 'connection lost',
					status: 'connetcion lost'
				},
				GameConfigs.App
			);
		}
	}

	setStatus(status) {
		statusHelper(status, this);
	}
}
